import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAssistant } from './AssistantProvider';
import { SparkIcon } from './icons';

/* Floating launcher button. Hidden while the panel is open. */
const Launcher = () => {
  const { t } = useTranslation('assistant');
  const { open, setOpen } = useAssistant();
  if (open) return null;
  return (
    <button
      type="button"
      className="bra-fab"
      aria-label={t('Open assistant')}
      onClick={() => setOpen(true)}
    >
      <SparkIcon />
    </button>
  );
};

export default Launcher;
